import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { usd } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertOctagon } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";

export function OverdueDepositAlert() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/tax-impound/batches").then((r) => setItems(r.data.items.filter((b) => b.overdue))).catch(() => {}); }, []);
  if (!items.length) return null;
  const total = items.reduce((s, b) => s + b.items.filter((i) => i.payment_status !== "paid" && i.due_date < new Date().toISOString().slice(0, 10)).reduce((t, i) => t + i.amount, 0), 0);
  const penalty = items.reduce((s, b) => s + (b.penalty_total || 0), 0);
  return (
    <div className="rounded-xl border-2 border-rose-400 bg-rose-50 p-4 flex items-start gap-3" data-testid="overdue-deposit-alert" role="alert">
      <AlertOctagon className="w-5 h-5 text-rose-600 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-semibold text-rose-900" data-testid="overdue-deposit-title">{usd(total)} in tax deposits past due across {items.length} payroll{items.length > 1 ? "s" : ""}{penalty > 0 && <span data-testid="overdue-deposit-penalty"> · ≈ {usd(penalty)} estimated IRS penalty</span>}</div>
        <p className="text-xs text-rose-800 mt-0.5">Late federal and state deposits accrue penalties daily. Remit these now and mark them paid with the agency confirmation number.</p>
        <ul className="mt-2 flex flex-wrap gap-2">
          {items.slice(0, 6).map((b) => <li key={b.id} data-testid={`overdue-deposit-${b.id}`} className="text-xs bg-white/70 border border-rose-200 rounded-md px-2 py-1"><span className="font-medium">{b.company_name}</span> · pay {fmtDate(b.pay_date)} · due {fmtDate(b.next_due)}</li>)}
          {items.length > 6 && <li className="text-xs text-rose-700 self-center">+{items.length - 6} more</li>}
        </ul>
      </div>
      <Button size="sm" variant="destructive" data-testid="overdue-deposit-go" onClick={() => navigate("/tax-impound")}>Remit now</Button>
    </div>
  );
}
